import React from 'react'
import { createFileRoute } from '@tanstack/react-router'

import { validateUserAddPermission } from "@/lib/api/auth"
import { Button } from "@/components/ui/button"
import {
  Credenza,
  CredenzaBody,
  CredenzaContent,
  CredenzaDescription,
  CredenzaHeader,
  CredenzaTitle,
} from '@/components/ui/credenza'
import ZonesForm from '@/components/forms/zones-form'
import { Header } from '@/components/header'
import { Icons } from '@/components/icons'

export const Route = createFileRoute('/_home/zone-settings/zones/add')({
  component: AddZonesPage,
})

export default function AddZonesPage() {
  const [showAddZoneTypeModal, setShowAddZoneTypeModal] = React.useState(false)
  React.useState<boolean>(false)
  return (
    <main className="space-y-4">
      <Button
        onClick={() => {
          if (!validateUserAddPermission()) return
          setShowAddZoneTypeModal(true)
        }}
      >
        <Icons.add className="size-4" />
        Add Zone
      </Button>
      <Credenza
        open={showAddZoneTypeModal}
        onOpenChange={setShowAddZoneTypeModal}
      >
        <CredenzaContent className="flex w-full max-w-[850px] justify-center">
          <CredenzaBody className="mx-auto w-full max-w-6xl px-4">
            <Header
              subroutes={[
                {
                  route: '/zone-settings/zones',
                  label: 'Zones',
                },
              ]}
            >
              Add Zone
            </Header>
            <ZonesForm setShowAddZoneTypeModal={setShowAddZoneTypeModal} />
          </CredenzaBody>
        </CredenzaContent>
      </Credenza>
    </main>
  )
}
